<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel } from '../../../pages/cms/modules/articles/_runtime/services/ArticleHeadlineCoversService';
import ArticleHeadlineCoversService from '../../../pages/cms/modules/articles/_runtime/services/ArticleHeadlineCoversService';

defineOptions({
    name: 'WidgetHeadlineCoverSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    isPhotoView: false,
    headlineCoverId: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function fetchHeadlineCover(id: number): Promise<ListItemModel>
{
    const response = await ArticleHeadlineCoversService.fetchAutocompleteModel(id);

    return response || null;
}

async function searchHeadlineCover(query: string, limit: number): Promise<ListItemModel[]>
{
    return await ArticleHeadlineCoversService.getAutocompleteList(query, limit);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Wybierz czołówkę]]]')">
        <IdeoFormGroup :invalid-feedback="form.$errors.first('isPhotoView')" :state="form.$errors.state('isPhotoView')">
            <IdeoFormCheckbox v-model="form.settings.isPhotoView" switch>
                {{ $t('[[[Widok czołówki - zdjęcie z tytułem]]]') }}
            </IdeoFormCheckbox>
        </IdeoFormGroup>
        <div class="d-flex flex-column flex-md-row">
            <div class="flex-grow-1">
                <IdeoAutocomplete
                    v-model="form.settings.headlineCoverId"
                    name="headlineCoverId"
                    track-by="id"
                    :placeholder="$t('[[[Wyszukaj czołówkę...]]]')"
                    :fetch="(id: number) => fetchHeadlineCover(id)"
                    :search="(query: string, limit: number) => searchHeadlineCover(query, limit)"
                >
                    <template #selected="{ option }">
                        <div class="text-wrap">
                            {{ option.name }}
                        </div>
                    </template>
                    <template #option="{ option }">
                        <div class="text-wrap">
                            {{ option.name }}
                        </div>
                    </template>
                </IdeoAutocomplete>
            </div>
        </div>
    </IdeoFormGroup>
</template>
